import { Clapperboard } from "lucide-react";
import SiteLayout from "@/components/site/SiteLayout";
import { useReelsData, ReelsGrid } from "@/components/site/Reels";

export default function ReelsPage() {
  const { reels, bizMap, loaded } = useReelsData();
  return (
    <SiteLayout>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6" data-testid="reels-page">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-11 h-11 rounded-2xl bg-primary/10 flex items-center justify-center"><Clapperboard className="w-5 h-5 text-primary" /></div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold font-heading text-foreground leading-tight">Reels</h1>
            <p className="text-sm text-muted-foreground">Vídeos dos comércios de Pocinhos. Toque para assistir.</p>
          </div>
        </div>
        {loaded && !reels.length && <p className="text-center text-muted-foreground py-16" data-testid="reels-empty">Nenhum vídeo publicado ainda.</p>}
        {reels.length > 0 && <ReelsGrid reels={reels} bizMap={bizMap} />}
      </div>
    </SiteLayout>
  );
}
